import React, { useRef, useState } from "react";
import { Grid, Typography } from "@material-ui/core";
import { ValidatorForm } from "react-material-ui-form-validator";
import { useStyles } from "../styles";
import FormInput from "../../FormInput";
import { UIViewButton } from "../../../ui/buttons";
 
const ConnectsS3Form = ({ values, onSubmit, onChange, disabled }) => {
    const classes = useStyles()
    const formRef = useRef()

    return (
        <Grid container>
            <Grid item container>
                <Typography className={classes.title}>Fill out the data</Typography>
            </Grid>
            <Grid item container>
                <ValidatorForm ref={formRef} onSubmit={onSubmit} className={classes.connectForm}>
                    <Grid container direction="column" className={classes.connectFormContent}>
                        <Grid item container className={classes.connectFormInputContainer}>
                            <Typography className={classes.connectFormInputLabel}>AWS Key ID</Typography>
                            <FormInput
                                name={"aws_access_key_id"}
                                value={values["aws_access_key_id"]}
                                autoFocus
                                onChange={onChange}
                                validators={['required']}
                                errorMessages={['AWS Key ID is required!']}
                            />    
                        </Grid>
                        <Grid item container className={classes.connectFormInputContainer}>
                            <Typography className={classes.connectFormInputLabel}>AWS Secret Access Key</Typography>
                            <FormInput
                                name={"aws_secret_access_key_id"}
                                value={values["aws_secret_access_key_id"]}
                                autoFocus
                                onChange={onChange}
                                validators={['required']}
                                errorMessages={['AWS Secret Access Key is required!']}
                            />    
                        </Grid>
                        <Grid item container className={classes.connectFormInputContainer}>
                            <Typography className={classes.connectFormInputLabel}>AWS Region</Typography>
                            <FormInput
                                name={"region_name"}
                                value={values["region_name"]}
                                autoFocus
                                onChange={onChange}
                                validators={['required']}
                                errorMessages={['AWS Region is required!']}
                            />    
                        </Grid>
                        <Grid item container className={classes.connectFormInputContainer}>
                            <Typography className={classes.connectFormInputLabel}>AWS Bucket Name</Typography>
                            <FormInput
                                name={"backet_name"}
                                value={values["backet_name"]}
                                autoFocus
                                onChange={onChange}
                                validators={['required']}
                                errorMessages={['AWS Bucket Name is required!']}
                            />    
                        </Grid>
                        <Grid item container className={classes.connectFormInputContainer}>
                            <Typography className={classes.connectFormInputLabel}>Filename</Typography>
                            <FormInput
                                name={"file_name"}
                                placeholder="Enter status name"
                                value={values["file_name"]}
                                autoFocus
                                onChange={onChange}
                            />    
                        </Grid>
                        <Grid item container justifyContent="center">
                            <UIViewButton
                                type="submit"
                                style={{ height: 40, width: 150, padding: 0 }}
                                data-testid="submitButton"
                                disabled={disabled}
                            >
                                Connect
                            </UIViewButton>
                        </Grid>
                    </Grid>
                </ValidatorForm>
            </Grid>
        </Grid>
    )
}

export default ConnectsS3Form